import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { ConnectService } from '@app/shared/services/connect.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
declare var $: any;
import swal from "sweetalert2";
import { ProfileMiniService } from '@app/feature/main/roles-shared/services/profile-mini.service';
import { CommentModalService } from '@app/shared/services/comment-modal.service';

@Component({
  selector: 'app-connect-mini-profile',
  templateUrl: './connect-mini-profile.component.html',
  styleUrls: ['./connect-mini-profile.component.css'],
  exportAs: 'ConnectMiniModal'
})
export class ConnectMiniProfileComponent implements OnInit {
  @ViewChild('ConnectMiniModal') public ConnectMiniModal: ModalDirective;
  @Output() refreshAPI: EventEmitter<any> = new EventEmitter();
  userProfileData: any;
  userRole: any;
  isAnalyst: boolean = false;
  userId: string = null;
  loggedInUser: string = null;
  isLoggedInUser: boolean = false;
  status: string = '';
  constructor(private profileMiniService: ProfileMiniService,
    private commentModalService: CommentModalService,
    private connectService: ConnectService, private router: Router, private authenticationService: AuthenticationService) {

  }

  ngOnInit() {
    if (window.sessionStorage.getItem('userDetails')) {
      this.loggedInUser = JSON.parse(window.sessionStorage.getItem('userDetails')).id;
    }
  }
  showModal() {
    this.ConnectMiniModal.show();
  }
  hideModal() {
    this.ConnectMiniModal.hide();
  }
  getProfileData(userId) {
    this.userId = userId;
    this.connectService.getProfileSnapshot(userId).subscribe((data: any) => {
      this.userProfileData = data;
      if (this.userProfileData.id) {
        this.isLoggedInUser = this.userProfileData.id === this.loggedInUser ? true : false;
      } else {
        this.isLoggedInUser = false;
      }
      if (data.connectStatus) {
        this.status = data.connectData.status;
      }
      else {
        this.status = 'disconnected';
      }
      if (this.userProfileData.code === 'tech_analyst') {
        this.isAnalyst = true;
      }
      else {
        this.isAnalyst = false;
      }
      this.showModal();
    }, error => {

    });
  }

  goToConnectionsPage(userId) {
    this.connectService.connectUser(userId).subscribe((data: any) => {
      this.hideModal();
      swal("Success", "Request sent successfully.", "success");
    }, (error) => {
      swal("Info", error.error.error.message, "info");
    });
  }
  viewProfile() {
    const userType = this.authenticationService.getLoggedUserType();
    this.router.navigate([`analyst-profile`], { queryParams: { analystId: this.userId } });
    this.hideModal();
    this.commentModalService.modalStatus(false, null);
  }
  viweMessagePage() {
    const userType = this.authenticationService.getLoggedUserType();
    this.router.navigate([`${userType}/messages`]);
    this.hideModal();
    this.commentModalService.modalStatus(false, null);
  }
  patchChangeConnectionSatus() {
    this.connectService.updateConnectionStatus(this.userId, 'connected').subscribe(
      (data: any) => {
        swal("Success", data, "success");
        this.hideModal();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      });
  }
  sentConnectionRequest() {
    this.connectService.connectUser(this.userId).subscribe(
      (data: any) => {
        swal("Success", data, "success");
        this.hideModal();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/connect-mini-profile/connect-mini-profile.component.ts